import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import consgif from "../Images/consgif.gif";
import co1 from "../Images/co1.jpg";
import const1 from "../Images/const1.jpg";
import imp1 from "../Images/imp1.jpg";
import const2 from "../Images/const2.jpg";
import { Link } from "react-router-dom";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";

export default function Construction() {
  return (
    <>
      <SEO
        title="AI ERP & CRM for Construction Industry"
        description="Optimize construction project planning, subcontractor management, material inventory, and cost estimation with EnteliPro AI ERP & CRM software."
        keywords="Construction ERP Software, Building Contractor CRM, Construction Management Software, Project Accounting ERP, Civil Engineering ERP"
        canonical="https://www.entelipro.com/Construction"
        ogImage="https://www.entelipro.com/static/media/consgif.gif"
      />

      <Navbar />

      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Construction Industry</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img src={consgif} alt="EnteliPro AI ERP for Construction and Civil Contracting" className="img-responsive " />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>
                  AI ERP Software for Construction Industry
                </h1>
                <p className="para">
                  The construction sector is one of the most sophisticated and fast-paced industries.
                  EnteliPro delivers intelligent ERP solutions tailored for general contractors,
                  subcontractors, and civil engineering firms to manage bids, budgets, and job sites in real time.
                </p>
                <div className="jst-two-coloums mt-4">
                  <div className="icon-text">
                    <p className="para">
                      Centralize project budgets, change orders, vendor procurement,
                      and labor time tracking under a single AI-powered ERP platform.
                    </p>
                  </div>
                  <div className="icon-text mt-lx-3 pt-lx-1">
                    <p className="para">
                      Automate compliance documentation, subcontractor insurance tracking,
                      and job-cost accounting to eliminate project budget overruns.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies construction-tight">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>How ERP & CRM Benefits Construction Companies</h3>
              <p className="para">
                Moving away from scattered spreadsheets and paper blueprints allows your teams
                to access live project milestones, bill of materials (BOM), and equipment availability on any mobile device.
              </p>
              <br />
              <p className="para">
                With {`${project_name}`}, your project managers and site engineers see subcontractor
                tasks, safety certifications, and material deliveries in real-time, helping projects finish on schedule and within budget.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img src={co1} alt="Construction Site Performance Monitoring with EnteliPro ERP" className="img-responsive " />
              </div>
              <div className="cwp4-text col-xl-6">
                <h4>Performance Monitoring</h4>
                <p className="para">
                  Employee and contractor ERP software makes it easy to monitor job site operations
                  both at an executive level and through detailed milestone views, ensuring accountability and safety compliance across all active builds.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="cwp4-text col-xl-6">
                <h4>Improved Collaboration</h4>
                <p className="para">
                  Standardize project communication between architects, site supervisors, and external contractors.
                  With all project blueprints, RFIs, and purchase orders accessible in one cloud portal, teams make faster decisions.
                </p>
              </div>
              <div className="col-xl-6 cwp4-image ">
                <img src={const1} alt="Construction Team Collaboration and Document Management" className="img-responsive " />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img src={imp1} alt="Construction Material Supply and Inventory Intelligence" className="img-responsive " />
              </div>
              <div className="cwp4-text col-xl-6">
                <h4>Improved Intelligence</h4>
                <p className="para">
                  From equipment dispatching and fuel logging to concrete pouring deadlines,
                  a construction contractor ERP keeps vital project telemetry at your fingertips to prevent costly delays.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="cwp4-text col-xl-6">
                <h4>Accurate Bidding & Forecasting</h4>
                <p className="para">
                  AI-driven forecasting models calculate accurate job margins based on historical material costs and labor expenditures,
                  ensuring your tenders remain competitive while protecting profit margins.
                </p>
              </div>
              <div className="col-xl-6 cwp4-image ">
                <img src={const2} alt="Construction Cost Estimation and Project Forecasting" className="img-responsive " />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}